import { Plugin } from './Plugin';
import { GlobalsPlugin } from './GlobalsPlugin';
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';

export class SMAAPlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.viewer.rendering.disableRenderPass = false;
		this.smaa = new SMAAPass(this.viewer.width, this.viewer.height);
		this.viewer.rendering.customPasses.add(this.smaa);
	}

	update(){
		this.manager.get(GlobalsPlugin).antialias = false;
	}
}